'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationConstants = require('../../validationConstants');

var PASSWORD_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.password,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    debounced: true,
    message: 'Must be at least 6 characters'
};

// This should be more complex in the future, however the only validation we're currently doing is on field length

exports.default = function (fieldValue, validationConfig) {
    return fieldValue.length < 6 ? PASSWORD_ERROR_OBJECT : null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/passwordValidator.js
// module id = 2308
// module chunks = 0